import {
  InvoiceApplicationFormDataInput,
  InvoiceApplicationFormDataRowInput,
  SelectionStateEnum,
} from '@monetize/types/app';
import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { roundNumberToDecimal } from '../../utils/numberUtils';

interface UseTransactionApplicationRowParams {
  index: number;
  formState: UseFormReturn<InvoiceApplicationFormDataInput>;
  row: InvoiceApplicationFormDataRowInput;
  /**
   * Currently unapplied amount of payment or credit
   */
  availableAmount: number;
}

/**
 * Shared per-row logic for the transaction application tables. Keeps the
 * checkbox selection state in sync with the applied amount and exposes the
 * toggle handler so both the default and refund rows behave identically.
 */
export const useTransactionApplicationRow = ({
  index,
  formState,
  row,
  availableAmount,
}: UseTransactionApplicationRowParams) => {
  const { setValue } = formState;
  const { appliedAmount, amountDueWithoutApplied, checkedState } = row;
  const amountDue = amountDueWithoutApplied - Number(appliedAmount);

  useEffect(() => {
    if (Number(appliedAmount) > 0 && amountDue === 0) {
      setValue(`rows.${index}.checkedState`, SelectionStateEnum.ALL);
    } else if (Number(appliedAmount) > 0) {
      setValue(`rows.${index}.checkedState`, SelectionStateEnum.SOME);
    } else {
      setValue(`rows.${index}.checkedState`, SelectionStateEnum.NONE);
    }
  }, [amountDue, appliedAmount, index, setValue]);

  const handleToggleCheckAll = () => {
    let newAppliedAmount = 0;
    if (
      checkedState === SelectionStateEnum.ALL ||
      checkedState === SelectionStateEnum.SOME
    ) {
      newAppliedAmount = 0;
    } else {
      newAppliedAmount = roundNumberToDecimal(
        Math.min(amountDue, availableAmount),
      );
    }
    if (appliedAmount !== newAppliedAmount) {
      setValue(`rows.${index}.appliedAmount`, newAppliedAmount);
    }
  };

  return { amountDue, handleToggleCheckAll };
};
